import React, { useEffect, useRef } from 'react';
import { sendReminderEmail } from '../../services/authService';

const SendReminEmail = ({ id, send, onSuccess }) => {
  const hasSent = useRef(false); // Flag to track if email has been sent

  console.log(hasSent, "hasSentHasSent")

  useEffect(() => {
    let timeoutId;

    // ✅ Reset hasSent if send becomes false
    if (!send) {
      hasSent.current = false;
      return;
    }


    const sendEmail = async () => {
      if (send && !hasSent.current) {
        hasSent.current = true; // Set flag to true

        try {
          const response = await sendReminderEmail({ id });
          const { message } = response.data;
          console.log(message, "messagemesmessage")
          if (typeof (message) == "string") {
          }
          onSuccess(message);

          timeoutId = setTimeout(() => {
            onSuccess('');
            // hasSent.current = false; // reset after showing message
          }, 3000);

          ////console.log("Success Message:", message);
        } catch (error) {
          console.error("Error sending reminder email:", error.message);
          onSuccess("Failed to send email.");

          timeoutId = setTimeout(() => {
            onSuccess('');
            // hasSent.current = false; // reset on error too
          }, 3000);
        }
      }
    };

    sendEmail();

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timeoutId);
  }, [send, id, onSuccess, hasSent]);

  return null;
};

export default SendReminEmail;